<template>
  <div class="card">
    <div class="card-header">
      <span>举报信息</span>
    </div>
    <div class="card-body">
        <z-row>
        <z-col span='5'>举报类型</z-col>
        <z-col span='19'>{{infoData.reason}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>举报时间</z-col>
        <z-col span='19'>{{infoData.time}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>事情经过</z-col>
        <z-col span='19'>{{infoData.content}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>截图凭证</z-col>
        <z-col span='19'>
          <ImageList :infoList="pics"></ImageList>
        </z-col>
      </z-row>
      <z-row v-if="infoData.moneyLoss > 0">
        <z-col span='5'>损失金额</z-col>
        <z-col span='19'>{{infoData.moneyLoss}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>对方昵称</z-col>
        <z-col span='19'>{{infoData.nickname}}</z-col>
      </z-row>
      <z-row>
        <z-col span='5'>违规凭证</z-col>
        <z-col span='19'>{{type[infoData.reportType]}}</z-col>
      </z-row>
    </div>
  </div>
</template>

<script>
import { Row, Col } from '@zz-common/zz-ui';
import ImageList from '../ImageList'
export default {
  name: 'InfoCard',
  props: {
    infoData: {
      default: () => {}
    }
  },
  components: {
    'z-row': Row,
    'z-col': Col,
    ImageList
  },
  data() {
    return {
      type: {
        1: '商品',
        2: '私信',
        3: '订单',
        4: '其他',
        5: '视频',
        6: '图片',
        7: '短视频',
        8: 'url',
        9: '帖子',
        11: '直播'
      }
    }
  },
  computed: {
    pics() {
      const { pics = '' } = this.infoData
      if (pics === '' || pics === '|') return [] //['https://pic1.zhuanstatic.com/zhuanzh/n_v2aca06eea57c14011972fcd81a7a27feb.jpg?w=200&t=5&qa=90','https://pic1.zhuanstatic.com/zhuanzh/n_v2aca06eea57c14011972fcd81a7a27feb.jpg?w=200&t=5&qa=90','https://pic1.zhuanstatic.com/zhuanzh/n_v2aca06eea57c14011972fcd81a7a27feb.jpg?w=200&t=5&qa=90','https://pic1.zhuanstatic.com/zhuanzh/n_v2aca06eea57c14011972fcd81a7a27feb.jpg?w=200&t=5&qa=90']
      return pics.split('|')
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>